export function getCollegeYears() {
  var year = new Date().getFullYear();
  var years = [];
  // User should not set the current year as GradYear value in July
  // (in June current year for GradYear still is a valid value)
  if (new Date().getMonth() + 1 > 6) {
    // we should to increase current year value
    year++;
  }
  for (var i = year; i <= year + 3; i++) {
    var text = i.toString();
    years.push({
      text: text
    });
  }
  return years;
}
export function isCredentialsValid(state) {
  var _state$credentials = state.credentials,
    email = _state$credentials.email,
    password = _state$credentials.password,
    error = _state$credentials.error;
  return email.valid && password.valid && !error;
}
export var emailDomains = ['aol.com', 'gmail.com', 'hotmail.com', 'icloud.com', 'yahoo.com'];
export var gdprCountries = {
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  CA: 'Canada',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DK: 'Denmark',
  EE: 'Estonia',
  ES: 'Spain',
  FI: 'Finland',
  FR: 'France',
  GB: 'United Kingdom',
  GR: 'Greece',
  HR: 'Croatia',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IN: 'India',
  IT: 'Italy',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  MT: 'Malta',
  MY: 'Malaysia',
  NL: 'Netherlands',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SA: 'Saudi Arabia',
  SE: 'Sweden',
  SI: 'Slovenia',
  SK: 'Slovakia',
  TR: 'Turkey',
  MX: 'Mexico',
  ZA: 'South Africa',
  HK: 'Hong Kong',
  AE: 'United Arab Emirates',
  SG: 'Singapore'
};
export function getCurrentView(state) {
  return state.showBack && state.backView || state.frontView;
}